<!-- String Input for Inspector -->
<script lang="ts">
  import Input from '@/ui/base/Input.svelte';

  let {
    value = $bindable(''),
    onChange,
  }: {
    value: string;
    onChange?: (value: string) => void;
  } = $props();

  function handleChange(newValue: string | number) {
    value = String(newValue);
    onChange?.(value);
  }
</script>

<Input type="text" {value} onChange={handleChange} extraClass="text-xs" />
